import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { CheckboxToggleInput } from '../../../../../components/form-components/inputs.component'
import { routes } from '../../../../../constants/routes.constants'
import { PRIMARY_COLOR } from '../../../../../styles/colors.style'
import Yup from './../../../../../helpers/custom-yup'

const schema = Yup.object().shape({
	termsAndConditions: Yup.boolean().shouldBeTrue(
		'Leia os termos e condições de uso'
	),
})

const StyledInputContainer = styled.div`
	margin-top: 4.5rem;
`

export default class TermsAndConditionsForm extends Component {
	constructor(props) {
		super(props)
		this.termsAndConditionsRef = React.createRef()
	}

	submit() {
		this.refs.form.submitForm()
	}

	componentWillMount() {
		const { subscribedToNewsletter: newsletter } = this.props.initialValues
		this.initialValues = {
			newsletter,
			termsAndConditions: true,
		}
	}

	render() {
		const { onSubmit } = this.props
		return (
			<Formik
				initialValues={this.initialValues}
				onSubmit={onSubmit}
				validationSchema={schema}
				ref={'form'}
				render={(props) => (
					<Form noValidate>
						<StyledInputContainer>
							<p>
								Declaro que li e concordo com os{' '}
								<Link
									to={routes.REGULAMENTO}
									className="gray"
									target="_blank">
									termos e condições de uso
								</Link>{' '}
								e com o{' '}
								<Link
									to={routes.POLITICAS}
									className="gray"
									target="_blank">
									termo de privacidade
								</Link>{' '}
								do programa Muviflex *
							</p>
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
								}}>
								<CheckboxToggleInput
									elementRef={this.termsAndConditionsRef}
									id="termsAndConditions"
									{...props}
								/>
								<p style={{ paddingLeft: '1rem' }}>
									{props.values.termsAndConditions ? (
										<span
											style={{
												color: PRIMARY_COLOR,
											}}>
											Sim
										</span>
									) : (
										'Não'
									)}
								</p>
							</div>
						</StyledInputContainer>
						<StyledInputContainer>
							<p>
								Aceito receber informações, dicas, pesquisa de
								satisfação e promoções do Muviflex por e-mail, torpedo,
								ligação telefônica e/ou whatsApp.
							</p>
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
								}}>
								<CheckboxToggleInput id="newsletter" {...props} />
								<p style={{ paddingLeft: '1rem' }}>
									{props.values.newsletter ? (
										<span
											style={{
												color: PRIMARY_COLOR,
											}}>
											Sim
										</span>
									) : (
										'Não'
									)}
								</p>
							</div>
						</StyledInputContainer>
					</Form>
				)}
			/>
		)
	}
}

TermsAndConditionsForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	onClick: PropTypes.func,
}
